import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { headerTitles } from "../../actions/masterdata/masterdata";

import banner from "./assets/loan_banner.png";
import car from "./assets/car_loan.png";
import home from "./assets/home_loan.png";
import personal from "./assets/personal_loan.png";
import tick from "./assets/circle_tick.png";
import "./Loan.css";
import { useTranslation } from "react-i18next";

const ApplyLoan = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      headerTitles({
        title: t("apply_loan"),
        description: "",
      })
    );
  }, []);

  const loanData = [
    {
      title: "Personal Loan",
      description:
        "For salaried individuals | No Collaterals Required | No Hidden Charges",
      benefits: ["Disbursal in 24hrs", "Flexible Tenures", "No hidden Charges"],
      buttonText: "Apply now",
      image: personal,
    },
    {
      title: "Home Loan",
      description:
        "Interest rates starting 8.50% p.a | Loan up to Rs. 15 Crs | Tenure up to 40 years",
      benefits: [
        "Approval in 48 hrs*",
        "Top-up loan up to 1 Crore",
        "Foreclosure Facility",
      ],
      buttonText: "Apply now",
      image: home,
    },
    {
      title: "Used Car Loan",
      description:
        "3 unique variants | Up to Rs. 77 Lakh | Tenure up to 72 months",
      benefits: [
        "Up to 115% funding on car",
        "In principle sanction letter",
        "Minimal documentation",
      ],
      buttonText: "Apply now",
      image: car,
    },
  ];

  // const CardDetailsJson = [
  //   {
  //     cardTitle: t("business_loan"),
  //     cardDescription: t("fuel_your_busin"),
  //     img: (
  //       <img
  //         src={BusinessLoanImg}
  //         alt='Business Loan Image'
  //         className='card-image'
  //       />
  //     ),
  //     pointsArray: [
  //       {
  //         pointsImage: <img src={Affirmative} alt='Affirmative' />,
  //         pointsDescription: t("avail_a_loan"),
  //       },
  //       {
  //         pointsImage: <img src={Affirmative} alt='Affirmative' />,
  //         pointsDescription: t("flexible_repay"),
  //       },
  //       {
  //         pointsImage: <img src={Affirmative} alt='Affirmative' />,
  //         pointsDescription: t("check_your_busine"),
  //       },
  //     ],
  //   },
  //   {
  //     cardTitle: t("work_cap_loan"),
  //     cardDescription: t("keep_your_business"),
  //     img: <img src={MyLoanImg} alt='My Loan Image' className='card-image' />,
  //     pointsArray: [
  //       {
  //         pointsImage: <img src={Affirmative} alt='Affirmative' />,
  //         pointsDescription: t("enjoy_credit"),
  //       },
  //       {
  //         pointsImage: <img src={Affirmative} alt='Affirmative' />,
  //         pointsDescription: t("access_pre"),
  //       },
  //       {
  //         pointsImage: <img src={Affirmative} alt='Affirmative' />,
  //         pointsDescription: t("get_loans_against"),
  //       },
  //     ],
  //   },
  //   {
  //     cardTitle: t("invoice_discountind"),
  //     cardDescription: t("drive_your_business"),
  //     img: (
  //       <img
  //         src={InvoiceDiscountImg}
  //         alt='Invoice Account Image'
  //         className='card-image'
  //       />
  //     ),
  //     pointsArray: [
  //       {
  //         pointsImage: <img src={Affirmative} alt='Affirmative' />,
  //         pointsDescription: t("get_up_loans"),
  //       },
  //       {
  //         pointsImage: <img src={Affirmative} alt='Affirmative' />,
  //         pointsDescription: t("access_up"),
  //       },
  //       {
  //         pointsImage: <img src={Affirmative} alt='Affirmative' />,
  //         pointsDescription: t("pay_at_your"),
  //       },
  //     ],
  //   },
  //   {
  //     cardTitle: t("loan_against"),
  //     cardDescription: t("get_instant"),
  //     img: (
  //       <img
  //         src={LoanAgainstPropertyImg}
  //         alt='Loan Against Property Image'
  //         className='card-image'
  //       />
  //     ),
  //     pointsArray: [
  //       {
  //         pointsImage: <img src={Affirmative} alt='Affirmative' />,
  //         pointsDescription: t("get_loans_up"),
  //       },
  //       {
  //         pointsImage: <img src={Affirmative} alt='Affirmative' />,
  //         pointsDescription: t("enjoy_longer"),
  //       },
  //       {
  //         pointsImage: <img src={Affirmative} alt='Affirmative' />,
  //         pointsDescription: t("both_residential"),
  //       },
  //     ],
  //   },
  // ];
  return (
    <section className="d-flex flex-col">
      {/* <div className="tabsSection">
        <span className="active mt1">{t("business_loan")}</span>
      </div> */}
      <img src={banner} />
      <div className="mt2 applyLoanCards-container">
        {/* {CardDetailsJson?.map((card) => {
          return (
            <div className='card d-flex flex-col'>
              <div className='card-header'>
                <span>{card.cardTitle}</span>
                <p className='card-description'>{card.cardDescription}</p>
              </div>
              <div className='card-with-image-points'>
                <span>{card.img}</span>

                <div>
                  {card.pointsArray?.map((point) => (
                    <div className='d-flex flex-col'>
                      <div className='card-points d-flex gap1'>
                        <div className='icon'>{point.pointsImage}</div>
                        <p className='card-points-description'>
                          {point.pointsDescription}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className='button-container mt1'>
                <button>{t("apply_online")}</button>
                <button className='outlineButton'>{t("know_more")}</button>
              </div>
            </div>
          );
        })} */}
        {loanData.map((loan, index) => (
          <LoanCard
            key={index}
            title={loan.title}
            description={loan.description}
            benefits={loan.benefits}
            buttonText={loan.buttonText}
            image={loan.image}
          />
        ))}
      </div>
    </section>
  );
};

const LoanCard = ({ title, description, benefits, buttonText, image }) => {
  return (
    <div className="loan-card card">
      <img
        src={image}
        style={{
          height: "6rem",
        }}
      />
      <div className="head-sec">
        <h3>{title}</h3>
        <p>{description}</p>
      </div>
      <ul className="benefits">
        {benefits.map((benefit, index) => (
          <li key={index}>
            <img src={tick} width={20} />
            {benefit}
          </li>
        ))}
      </ul>
      <div className="button-container mt1">
        <button
          className="apply-btn"
          onClick={() => {
            window.open(`https://loans.syntizen.app/`);
          }}
        >
          {buttonText}
        </button>
        <button className="outlineButton">More Details</button>
      </div>
    </div>
  );
};

export default ApplyLoan;
